import { SvgIconProps } from "designSystem/index";
import React, { FunctionComponent } from "react";

const SnapshotEmptyIcon: FunctionComponent<SvgIconProps> = () => {
	return (
		<svg
			fill="none"
			height="181"
			viewBox="0 0 268 181"
			width="268"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_175_2223)">
				<rect
					fill="white"
					height="181"
					width="268"
				/>
				<g filter="url(#filter0_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M4 7C4 5.34315 5.34315 4 7 4H81C82.6569 4 84 5.34315 84 7V96.2C84 97.8568 82.6569 99.2 81 99.2H7C5.34315 99.2 4 97.8568 4 96.2V7Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M4.5 7C4.5 5.61929 5.61929 4.5 7 4.5H81C82.3807 4.5 83.5 5.61929 83.5 7V96.2C83.5 97.5807 82.3807 98.7 81 98.7H7C5.61929 98.7 4.5 97.5807 4.5 96.2V7Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="10.3999"
					y="10.3999"
				/>
				<path
					clipRule="evenodd"
					d="M10.3999 85.6C10.3999 84.7163 11.1162 84 11.9999 84H42.3999C43.2836 84 43.9999 84.7163 43.9999 85.6C43.9999 86.4837 43.2836 87.2 42.3999 87.2H11.9999C11.1162 87.2 10.3999 86.4837 10.3999 85.6Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M10.3999 91.9999C10.3999 91.1162 11.1162 90.3999 11.9999 90.3999H75.9999C76.8836 90.3999 77.5999 91.1162 77.5999 91.9999C77.5999 92.8836 76.8836 93.5999 75.9999 93.5999H11.9999C11.1162 93.5999 10.3999 92.8836 10.3999 91.9999Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M58.4001 32V54.4C58.4001 56.16 56.9601 57.6 55.2001 57.6H32.8001C31.0401 57.6 29.6001 56.16 29.6001 54.4V32C29.6001 30.24 31.0401 28.8 32.8001 28.8H55.2001C56.9601 28.8 58.4001 30.24 58.4001 32ZM42.3877 50.6102L38.3569 45.9244L32.7136 52.9298H55.2866L48.031 43.5892L42.3877 50.6102Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<g filter="url(#filter1_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M94 7C94 5.34315 95.3431 4 97 4H171C172.657 4 174 5.34315 174 7V96.2C174 97.8568 172.657 99.2 171 99.2H97C95.3431 99.2 94 97.8568 94 96.2V7Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M94.5 7C94.5 5.61929 95.6193 4.5 97 4.5H171C172.381 4.5 173.5 5.61929 173.5 7V96.2C173.5 97.5807 172.381 98.7 171 98.7H97C95.6193 98.7 94.5 97.5807 94.5 96.2V7Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="100.4"
					y="10.3999"
				/>
				<path
					clipRule="evenodd"
					d="M100.4 85.6C100.4 84.7163 101.116 84 102 84H133.2C134.084 84 134.8 84.7163 134.8 85.6C134.8 86.4837 134.084 87.2 133.2 87.2H102C101.116 87.2 100.4 86.4837 100.4 85.6Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M100.4 91.9999C100.4 91.1162 101.116 90.3999 102 90.3999H166C166.884 90.3999 167.6 91.1162 167.6 91.9999C167.6 92.8836 166.884 93.5999 166 93.5999H102C101.116 93.5999 100.4 92.8836 100.4 91.9999Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M148.4 32V54.4C148.4 56.16 146.96 57.6 145.2 57.6H122.8C121.04 57.6 119.6 56.16 119.6 54.4V32C119.6 30.24 121.04 28.8 122.8 28.8H145.2C146.96 28.8 148.4 30.24 148.4 32ZM132.388 50.6102L128.357 45.9244L122.714 52.9298H145.287L138.031 43.5892L132.388 50.6102Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<g filter="url(#filter2_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M184 7C184 5.34315 185.343 4 187 4H261C262.657 4 264 5.34315 264 7V96.2C264 97.8568 262.657 99.2 261 99.2H187C185.343 99.2 184 97.8568 184 96.2V7Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M184.5 7C184.5 5.61929 185.619 4.5 187 4.5H261C262.381 4.5 263.5 5.61929 263.5 7V96.2C263.5 97.5807 262.381 98.7 261 98.7H187C185.619 98.7 184.5 97.5807 184.5 96.2V7Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="190.4"
					y="10.3999"
				/>
				<path
					clipRule="evenodd"
					d="M190.4 85.6C190.4 84.7163 191.116 84 192 84H222.4C223.284 84 224 84.7163 224 85.6C224 86.4837 223.284 87.2 222.4 87.2H192C191.116 87.2 190.4 86.4837 190.4 85.6Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M190.4 91.9999C190.4 91.1162 191.116 90.3999 192 90.3999H256C256.884 90.3999 257.6 91.1162 257.6 91.9999C257.6 92.8836 256.884 93.5999 256 93.5999H192C191.116 93.5999 190.4 92.8836 190.4 91.9999Z"
					fill="#EDF0F5"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M238.4 32V54.4C238.4 56.16 236.96 57.6 235.2 57.6H212.8C211.04 57.6 209.6 56.16 209.6 54.4V32C209.6 30.24 211.04 28.8 212.8 28.8H235.2C236.96 28.8 238.4 30.24 238.4 32ZM222.388 50.6102L218.357 45.9244L212.714 52.9298H235.287L228.031 43.5892L222.388 50.6102Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<g filter="url(#filter3_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M4 111.2C4 109.543 5.34315 108.2 7 108.2H81C82.6569 108.2 84 109.543 84 111.2V200.4C84 202.057 82.6569 203.4 81 203.4H7C5.34315 203.4 4 202.057 4 200.4V111.2Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M4.5 111.2C4.5 109.819 5.61929 108.7 7 108.7H81C82.3807 108.7 83.5 109.819 83.5 111.2V200.4C83.5 201.781 82.3807 202.9 81 202.9H7C5.61929 202.9 4.5 201.781 4.5 200.4V111.2Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="10.3999"
					y="114.6"
				/>
				<path
					clipRule="evenodd"
					d="M58.4001 136.2V158.6C58.4001 160.36 56.9601 161.8 55.2001 161.8H32.8001C31.0401 161.8 29.6001 160.36 29.6001 158.6V136.2C29.6001 134.44 31.0401 133 32.8001 133H55.2001C56.9601 133 58.4001 134.44 58.4001 136.2ZM42.3877 154.81L38.3569 150.124L32.7136 157.13H55.2866L48.031 147.789L42.3877 154.81Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<g filter="url(#filter4_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M94 111.2C94 109.543 95.3431 108.2 97 108.2H171C172.657 108.2 174 109.543 174 111.2V200.4C174 202.057 172.657 203.4 171 203.4H97C95.3431 203.4 94 202.057 94 200.4V111.2Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M94.5 111.2C94.5 109.819 95.6193 108.7 97 108.7H171C172.381 108.7 173.5 109.819 173.5 111.2V200.4C173.5 201.781 172.381 202.9 171 202.9H97C95.6193 202.9 94.5 201.781 94.5 200.4V111.2Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="100.4"
					y="114.6"
				/>
				<path
					clipRule="evenodd"
					d="M148.4 136.2V158.6C148.4 160.36 146.96 161.8 145.2 161.8H122.8C121.04 161.8 119.6 160.36 119.6 158.6V136.2C119.6 134.44 121.04 133 122.8 133H145.2C146.96 133 148.4 134.44 148.4 136.2ZM132.388 154.81L128.357 150.124L122.714 157.13H145.287L138.031 147.789L132.388 154.81Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<g filter="url(#filter5_d_175_2223)">
					<path
						clipRule="evenodd"
						d="M184 111.2C184 109.543 185.343 108.2 187 108.2H261C262.657 108.2 264 109.543 264 111.2V200.4C264 202.057 262.657 203.4 261 203.4H187C185.343 203.4 184 202.057 184 200.4V111.2Z"
						fill="white"
						fillRule="evenodd"
					/>
					<path d="M184.5 111.2C184.5 109.819 185.619 108.7 187 108.7H261C262.381 108.7 263.5 109.819 263.5 111.2V200.4C263.5 201.781 262.381 202.9 261 202.9H187C185.619 202.9 184.5 201.781 184.5 200.4V111.2Z" stroke="#FAFBFC" />
				</g>
				<rect
					fill="#EDF0F5"
					height="67.2"
					rx="2"
					width="67.2"
					x="190.4"
					y="114.6"
				/>
				<path
					clipRule="evenodd"
					d="M238.4 136.2V158.6C238.4 160.36 236.96 161.8 235.2 161.8H212.8C211.04 161.8 209.6 160.36 209.6 158.6V136.2C209.6 134.44 211.04 133 212.8 133H235.2C236.96 133 238.4 134.44 238.4 136.2ZM222.388 154.81L218.357 150.124L212.714 157.13H235.287L228.031 147.789L222.388 154.81Z"
					fill="#FEFEFE"
					fillRule="evenodd"
				/>
				<path
					clipRule="evenodd"
					d="M0 154H268V181H0V154Z"
					fill="url(#paint0_linear_175_2223)"
					fillRule="evenodd"
				/>
			</g>
			<defs xmlns="http://www.w3.org/2000/svg">
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter0_d_175_2223"
					width="92"
					x="-2"
					y="1"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter1_d_175_2223"
					width="92"
					x="88"
					y="1"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter2_d_175_2223"
					width="92"
					x="178"
					y="1"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter3_d_175_2223"
					width="92"
					x="-2"
					y="105.2"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter4_d_175_2223"
					width="92"
					x="88"
					y="105.2"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<filter
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
					height="107.2"
					id="filter5_d_175_2223"
					width="92"
					x="178"
					y="105.2"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy="3" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0677721 0 0 0 0 0.196733 0 0 0 0 0.408345 0 0 0 0.05 0" />
					<feBlend
						in2="BackgroundImageFix"
						mode="normal"
						result="effect1_dropShadow_175_2223"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_175_2223"
						mode="normal"
						result="shape"
					/>
				</filter>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="paint0_linear_175_2223"
					x1="1.61054"
					x2="1.61054"
					y1="154"
					y2="181"
				>
					<stop stopColor="white" stopOpacity="0.01" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<clipPath id="clip0_175_2223">
					<rect
						fill="white"
						height="181"
						width="268"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default SnapshotEmptyIcon;